import service from '@/utils/request'
// 查询操作日志记录
export function sysOperLogList(param) {
	return service.request({
		method: 'post',
		url: '/app/sysOperLog/sysOperLogList',
		data: param
	})
}
// 清空日志记录
export function clearSysOperLog(param) {
	return service.request({
		method: 'post',
		url: '/app/sysOperLog/clear',
		data: param
	})
}
// 修改操作日志记录
export function editSysOperLog(param) {
	return service.request({
		method: 'post',
		url: '/app/sysOperLog/edit',
		data: param
	})
}
// 删除操作日志记录
export function delSysOperLog(param) {
	return service.request({
		method: 'post',
		url: '/app/sysOperLog/del',
		data: param
	})
}
// 导出操作日志记录
export function exportSysOperLog(param) {
	return service.request({
		method: 'post',
		url: '/app/sysOperLog/export',
		data: param
	})
}
